@if (httpError == '404') {
	<mat-error class="top-right-absolute-error-message">
		{{ 'mes.administration.terminal.shared.errors.not-found' | translate }}
	</mat-error>
}
@if (httpError == '500') {
	<mat-error class="top-right-absolute-error-message">
		{{ 'mes.administration.terminal.shared.errors.internal-server-error' | translate }}
	</mat-error>
}

<h1 mat-dialog-title class="notification-title no-select">
	{{ 'mes.administration.terminal.delete.heading' | translate }}
</h1>
<div mat-dialog-content>
	<p>{{ 'mes.administration.terminal.delete.content' | translate: { alias: terminal.alias } }}</p>
</div>
<div mat-dialog-actions>
	<button mat-flat-button color="primary" (click)="onDelete()" (window:keyup.enter)="onDelete()" [disabled]="loading">
		{{ 'mes.administration.terminal.shared.okbtn' | translate }}
	</button>
	<button mat-flat-button color="primary" (click)="onCancel()" (window:keyup.escape)="onCancel()">
		{{ 'mes.administration.terminal.shared.cancelbtn' | translate }}
	</button>
</div>
